import React from 'react';
import { Link } from 'react-router-dom';

export default function ProjectCard({ project }) {
  return <article className="project-card">
    <div className="project-index" aria-hidden="true">{project.number}</div>
    <div className="project-card-main">
      <div className="project-kicker">
        <p className="eyebrow">{project.category}</p>
        {project.status && <span className="status-badge">{project.status}</span>}
      </div>
      <h3>{project.title}</h3>
      <p className="project-summary">{project.summary}</p>
      <p className="project-focus"><strong>Focus:</strong> {project.focus}</p>
      <div className="tag-list" aria-label={`${project.title} technologies`}>{project.stack.map((item) => <span className="tag" key={item}>{item}</span>)}</div>
    </div>
    <div className="project-links">
      <Link className="text-link" to={`/project/${project.slug}`}>Read case study <span aria-hidden="true">↗</span></Link>
      <a className="muted-link" href={project.github} target="_blank" rel="noreferrer">Repository <span aria-hidden="true">↗</span></a>
    </div>
  </article>;
}
